<script setup lang="ts">
import { computed, inject } from 'vue';
import { AnalyticsClickBehaviour } from '@pkg/config/misc/analyticsClickBehaviour';
import { AppStore } from '@pkg/sanity-utils/constants/appstore';
import { logger } from '@pkg/logger';
import { AnalyticsAppStore } from '@pkg/analytics-helper/src/constants/analyticsAppStore';
import { appStoreAnalyticsKey, useAppStoresConfig } from '../../../frontend/appStores';

interface Props {
  link: string;
}

const props = defineProps<Props>();

const appStores = useAppStoresConfig();
const analytics = inject(appStoreAnalyticsKey, null);

const badgeUrl = computed(() => appStores.value?.[AppStore.GOOGLE_PLAY_STORE_BADGE]);
const badge = computed(() => {
  if (!badgeUrl.value) return null;
  const separator = badgeUrl.value.includes('?') ? '&' : '?';
  return `${badgeUrl.value}${separator}w=250&h=83`;
});

const eventHandler = () => {
  try {
    analytics?.trackDownloadApp(AnalyticsAppStore.PLAY);
  } catch (error) {
    logger.error('[GooglePlay] download tracking failed', error);
  }
};
</script>

<template>
  <NuxtLink
    v-if="badge"
    :to="props.link"
    target="_blank"
    :data-analytics-click-behaviour="AnalyticsClickBehaviour.DownloadApp"
  >
    <img
      class="max-h-40 max-w-[250px] amp-auto-track"
      width="135"
      height="40"
      :src="badge"
      alt="Get it on Google Play"
      loading="lazy"
      @click="eventHandler"
    >
  </NuxtLink>
</template>
